import useNotification from './use-notification';

export default useNotification;
